import React from "react";

import { FilterButton } from "./FilterButton";
import { colors } from "@/app/constants/styles";

interface SelectedFilterButtonProps {
  text: string;
  onPress: () => void;
}

const SelectedFilterButton: React.FC<SelectedFilterButtonProps> = ({
  onPress,
  text,
}) => (
  <FilterButton
    testID="selectedFilterButton"
    backgroundColor={colors.maroon}
    color={colors.white}
    onPress={onPress}
    text={text}
  />
);

export { SelectedFilterButton };
